import { z } from 'zod';

export const forgotPasswordSchema = z.object({
  email: z.email({ error: 'auth:validation.email' }),
});

export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>;
